/**
 * Controla la tabla de inspecciones.
 */
CamposExtraBooleanCtrl.$inject = [];

export default function CamposExtraBooleanCtrl() {
    const campExtBol = this;
    campExtBol.hasError = false;
    campExtBol.claseRow = issetAndNotEmpty(campExtBol.claseRow) ? campExtBol.claseRow == 'true' : true;

    campExtBol.validate = function () {

        if (campExtBol.campoExtra.valor === true || campExtBol.campoExtra.valor === false) {
            campExtBol.hasError = false;
            campExtBol.campoExtra.changed = true;
        } else {
            campExtBol.hasError = campExtBol.campoExtra.valor !== "";
            campExtBol.campoExtra.changed = false;
        }
    };

    campExtBol.borrar = function () {
        campExtBol.campoExtra.valor = null;
        campExtBol.campoExtra.changed = true;
    }

    const asignarFalseDefecto = issetAndNotEmpty(campExtBol.asignarFalseDefecto)
        ? campExtBol.asignarFalseDefecto == 'true' : false;

    if (issetAndNotEmpty(campExtBol.campoExtra.valor))
        campExtBol.campoExtra.valor = campExtBol.campoExtra.valor === "1";
    else if (asignarFalseDefecto) {
        campExtBol.campoExtra.valor = false
        campExtBol.validate();
    }

}